import { Injectable } from "@angular/core";
import { OAuthService, EventType } from "angular-oauth2-oidc";
import { authConfig } from "../helpers/auth.config";
import { filter } from "rxjs/operators";
import { Subject } from "rxjs";
import { ACTIVE_COMPANY_KEY } from "../helpers/storage-keys";

@Injectable()
export class AuthenticationService {
    userProfile: any;
    logoutEvent: EventType = "logout";
    private navigatingToLogin = false;

    constructor(public oauthService: OAuthService) {
        this.oauthService.configure(authConfig);
        // Cross-tab logout: when another tab removes the OAuth access token
        // from localStorage, force this tab to log out too.
        window.addEventListener("storage", (event) => {
            if (event.key === "access_token" && event.newValue === null) {
                this.redirectToLogin();
            }
        });
        //this.oauthService.skipIssuerCheck = true;
        //this.oauthService.strictDiscoveryDocumentValidation = false;

        this.oauthService.loadDiscoveryDocument().then(() => {
            //Load profile if there's an access Token
            if (this.isAuthenticated()) {
                this.loadUserProfile().then((userProfile) => {
                    this.userProfile = userProfile;
                });
            }
        });
    }

    loadUserProfile() {
        return this.oauthService.loadUserProfile();
    }

    tokenReceived() {
        return this.oauthService.events.pipe(
            filter((event) => {
                return ["token_received"].includes(event.type);
            }),
        );
    }

    userProfileLoaded() {
        return this.oauthService.events.pipe(
            filter((event) => {
                return ["user_profile_loaded"].includes(event.type);
            }),
        );
    }

    loggedOut() {
        return this.oauthService.events.pipe(
            filter((event) => {
                return this.logoutEvent == event.type;
            }),
        );
    }

    isAuthenticated() {
        return this.oauthService.hasValidAccessToken();
    }

    login(username: string, password: string) {
        return this.oauthService.fetchTokenUsingPasswordFlowAndLoadUserProfile(
            username,
            password,
        );
    }

    logout() {
        this.oauthService.logOut(true);
        localStorage.removeItem(ACTIVE_COMPANY_KEY);
        this.redirectToLogin();
    }

    private redirectToLogin() {
        if (this.navigatingToLogin) {
            return;
        }
        this.navigatingToLogin = true;
        window.location.href = "/login";
    }

    getAccessToken() {
        return this.oauthService.getAccessToken();
    }

    getClaims() {
        return this.oauthService.getIdentityClaims();
    }

    getUserProfile() {
        return this.userProfile;
    }

    getUserEmail(): string {
        return this.getClaims()["email"];
    }

    isAdmin(): boolean {
        return this.getClaims()["role"] === "Admin";
    }

    isManager(): boolean {
        return this.getClaims()["role"] === "Manager";
    }

    isClient(): boolean {
        return this.getClaims()["role"] === "SenriClient";
    }

    passwordCorrectSubject = new Subject<boolean>();

    setPasswordCorrectness(result: boolean) {
        this.passwordCorrectSubject.next(result);
    }
}
